<template>
  <div>
    <div class="py-2 d-flex justify-content-between">
      <b-link @click="switchButton"><div size="lg" :class="switchs?'SelectBtn primaryGColor':'SelectNBtn'">{{ mainName }}<br>{{ title }}<br><b-icon icon="chevron-compact-down" :animation="switchs?'cylon-vertical':''"></b-icon></div></b-link>
      <b-link @click="switchButton"><div class="text-right" size="lg" :class="!switchs?'SelectBtn primaryGColor':'SelectNBtn'">{{ secName }}<br>{{ title }}<br><b-icon icon="chevron-compact-down" :animation="switchs?'cylon-vertical':''"></b-icon></div></b-link>
    </div>
    <PlusClothCard v-if="switchs" :title="mainName+'加分穿搭'" :listdata="Alistdata" :color="Acolor"></PlusClothCard>
    <PlusClothCard v-else :title="secName+'加分穿搭'" :listdata="Blistdata" :color="Bcolor"></PlusClothCard>

  </div>



</template>
<style>

  .SelectBtn{
    color: #fff;
    background-color: #be9167;
    border-radius: 1rem !important;
    padding: 1rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  }
  .SelectNBtn{

    background-color: #00000000;
    border-radius: 1rem !important;
    padding: 1rem;
  }

</style>
<script>
import PlusClothCard from '@/components/PlusClothCard.vue'

export default {
  name: 'SwitchPlusClothCard',
  components: {PlusClothCard},
  props: {
    Alistdata: Array,
    Blistdata: Array,
    Acolor:String,
    Bcolor:String,
    title:String,
    mainName: String,
    secName: String,
  },
  computed: {
    switchs:function () {return this.selection==0?true:false;}
  },
  data () {
    return {
      selection:0

    }
  },
  methods: {
    switchButton:function () {
      this.selection==0?this.selection=1:this.selection=0;
    }

  }
}
</script>
